import React from 'react';

const MessageParser = ({ children, actions }: any) => {
  const parse = (message: any) => {
      console.log(message);
      actions.sendUserWsMessage(message)
  };

  return (
    <>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          parse: parse,
          actions
        });
      })}
    </>
  );
};

export default MessageParser;